import { useMutation } from '@tanstack/react-query';
import { useAlert } from '../../../../AlertProvider';
import ConfirmationModal from '../../../../components/ConfirmationModal';
import { alertType } from '../../../../constants/alertTypeConstant';
import { successStatus } from '../../../../constants/requestStatusContants';
import { deleteService } from '../../../../services/serviceService';

interface Props {
    serviceId?: string;
    serviceName?: string;
    setModalOpened: (param: boolean) => void;
    modalOpened: boolean;
}

function ServiceDeleteConfirmation(props: Props) {
    const {
        serviceId = '',
        serviceName = '',
        setModalOpened,
        modalOpened,
    } = props;
    const alert = useAlert();

    const { mutate } = useMutation({
        mutationFn: async () => {
            const { data, status } = await deleteService(serviceId);
            if (successStatus.includes(status)) {
                alert.show({
                    children: 'Le service a été supprimé avec succès',
                    type: alertType[status],
                });
            } else {
                alert.show({
                    children:
                        'Erreur! Une erreur est survenue. Veuillez réessayer plus tard.',
                    type: alertType[status],
                });
            }
            return data;
        },
    });

    const handleDeleteServiceClick = () => {
        mutate();
        setModalOpened(false);
    };

    return (
        <ConfirmationModal
            modalOpened={modalOpened}
            setModalOpened={setModalOpened}
            confirmationAction={handleDeleteServiceClick}
        >
            <span>
                Voulez-vous vraiment supprimer le service {serviceName}?
            </span>
        </ConfirmationModal>
    );
}

export default ServiceDeleteConfirmation;
